/**
 * Pricing block script.
 */

(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
	  define([], factory(root));
	} else if ( typeof exports === 'object' ) {
	  module.exports = factory(root);
	} else {
	  root.PricingBlock = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var _hasInitialized = false;
	var _publicMethods = {};
	var _settings = {
		tabsSelector: '.pricing__tabs',
		labelSelector: '.pricing__tabs-menu .pricing__tabs-menu-item label',
		labelForSelectorTemplate: 'label[for="###TAB_ID###"]',
		inputSelector: '.pricing__tab input[type="radio"]',

		selectedClass: 'selected',
	};



	var handleChange = function( e ) {
		// TAB RADIO INPUT
		if ( e.target.matches( _settings.inputSelector ) ) {
			var labelForSelector = _settings.labelForSelectorTemplate.replace( '###TAB_ID###', e.target.id );
			var labelElement = e.target.closest( _settings.tabsSelector ).querySelector( labelForSelector );

			// Remove selected class from all labels
			var labelElements = e.target.closest( _settings.tabsSelector ).querySelectorAll( _settings.labelSelector );
			labelElements.forEach( function( labelElement ) {
				labelElement.classList.remove( _settings.selectedClass );
			});

			// Add selected class to target label
			labelElement.classList.add( _settings.selectedClass );
		}
	};



	/**
	 * Initialize
	 */
	_publicMethods.init = function() {
		if ( _hasInitialized ) return;

		// Add event listeners
		document.addEventListener( 'change', handleChange );

		_hasInitialized = true;
	};



	//
	// Initialize on load
	//
	_publicMethods.init();

	//
	// Public APIs
	//
	return _publicMethods;

});
